<template>
  <div class="containerBox" ref="box">
    <!--  顶部导航  -->
    <nav-bar/>
    <!--  轮播图  -->
    <banner-list :banner-list="bannerList"/>
    <!--  行业痛点  -->
    <div class="points container">
      <div class="title" v-scroll-reveal>行业痛点</div>
      <div class="title_border" v-scroll-reveal></div>
      <div class="pointsBox">
        <img class="pointsBox_left" v-scroll-reveal :src="pointsData[pointsIndex]?.imgSrc" alt="">
        <div class="pointsBox_right" v-scroll-reveal>
          <div class="pointsBox_right_item" :class="{pointsBox_right_item_a: index === pointsIndex}"
               v-for="(item, index) in pointsData" :key="index" @mouseover="pointsover(index)" @mouseleave="setTimer">
            <img v-if="index !== pointsIndex" class="icon"
                 src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/points.png" alt=""/>
            <img v-if="index === pointsIndex" class="icon_a"
                 src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/points_a.png" alt=""/>
            <div class="pointsBox_right_item_right">
              <div class="pointsBox_title">{{ item.title }}</div>
              <p v-if="index === pointsIndex">{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  方案优势  -->
    <div id="superiority">
      <div class="title" v-scroll-reveal style="color: #FFFFFF">方案优势</div>
      <div class="title_border" v-scroll-reveal></div>
      <p v-scroll-reveal>（1）整合物流资源，打通行业各个环节，让物流行业迈入集成化、规范化、一体化，让物流变简单</p>
      <img v-scroll-reveal src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/superiority.png"
           alt="">
    </div>
    <!--  方案优势2  -->
    <div class="superiority2 container">
      <div class="superiority2_title" v-scroll-reveal>（2）合规获取物流成本票、保证税务合规</div>
      <p v-scroll-reveal>提供个体司机带票运输解决方案，物流企业合法取得个体司机运输发票，避免“白条”风险，确保数据真实，
        保证税务合规。</p>
      <img v-scroll-reveal src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/superiority2.png"
           alt="">
    </div>
    <!--  方案优势3  -->
    <div id="superiority3">
      <div class="superiority2_title" v-scroll-reveal>（3）物流行业五流合一</div>
      <p v-scroll-reveal>随着物流监管趋严，数字化信息技术应用，传统物流经营逐步趋向合规，行业朝着有序健康方向发展</p>
      <img v-scroll-reveal src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/superiority3.png"
           alt=""/>
    </div>
    <!--  为什么选择我们  -->
    <div class="chose" v-scroll-reveal>
      <div class="chose_top">
        <div class="chose_top_first">
          <span>Why choose us</span>
          <div class="chose_top_first_pos">（4）为什选择我们</div>
        </div>
        <div class="chose_top_item">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/xitong.png" alt=""/>
          <div class="chose_top_item_title">系统优势System advantages：</div>
          <p>数字系统功能强大，多方角色多种场景实时调度实时监管，智能结算数智分析</p>
        </div>
        <div class="chose_top_item">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/fuwu.png" alt=""/>
          <div class="chose_top_item_title">服务优势Service advantage：</div>
          <p>深度运营全程支持，7*24 小时一站式服务数智运维一键赋能，区域直扶无忧合作</p>
        </div>
      </div>
      <div class="chose_top" style="margin-top: 20px;">
        <div class="chose_top_item">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/zhengce.png" alt=""/>
          <div class="chose_top_item_title">政策优势Policy advantage：</div>
          <p>资质牌照申请便捷，全程1对1指导数字政府财政奖补，政企桥梁降本增效</p>
        </div>
        <div class="chose_top_item">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/jishu.png" alt=""/>
          <div class="chose_top_item_title">技术优势Technical superiority：</div>
          <p>专业技术团队加持，强势领先行业对手数字系统迭代升级，深耕市场快速响应</p>
        </div>
        <div class="chose_top_item">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/pinpai.png" alt=""/>
          <div class="chose_top_item_title">品牌优势Brand advantage：</div>
          <p>货满满在行业有多年的品牌优势，在行业内有 一定知名度</p>
        </div>
      </div>
    </div>
    <!--  方案优势4  -->
    <div id="superiority4">
      <div class="container2">
        <div class="item" v-scroll-reveal v-for="(item, index) in superiorityData" :key="index">
          <!--     鼠标没划入     -->
          <div class="item1">
            <img :src="item.icon" alt="">
            <div class="item1_title">{{ item.name }}</div>
          </div>
          <!--     鼠标划入     -->
          <div class="item2" v-scroll-reveal>
            <p v-if="index !== 1" class="item2_title">{{ item.content }}</p>
            <p v-if="index === 1" class="item2_title">{{ item.content1 }}</p>
            <p v-if="index === 1" class="item2_content">{{ item.content2 }}</p>
            <p v-if="index === 1" class="item2_title" style="margin-top: 20px;">{{ item.content3 }}</p>
            <p v-if="index === 1" class="item2_content">{{ item.content4 }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--  底部  -->
    <bottom-footer/>
    <!--  悬浮按钮  -->
    <fix-anchor @goBottom="goBottom"/>
  </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue';
import BannerList from '@/components/banner-list.vue';
import BottomFooter from '@/components/bottom-footer.vue';
import FixAnchor from '@/components/fix-anchor.vue';
import 'swiper/dist/js/swiper';
import 'swiper/dist/css/swiper.css';

export default {
  name: 'StatusQuo',
  components: {
    NavBar,
    BannerList,
    BottomFooter,
    FixAnchor,
  },
  data() {
    return {
      timer: null,
      bannerList: [{coverImgUrl: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/banner/status_banner.png'}],
      pointsIndex: 0,
      pointsData: [
        {
          id: 1,
          title: '1.开票难',
          content: '全国个体运输户占比高达91.3%，个体运输户开票难，无法提供运输发票，导致物流企业增值税断裂，企业进项获取困难，将面临较大的涉税风险，网络货运一经推出便取得较大的市场规模。',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/points_bg1.png'
        },
        {
          id: 2,
          title: '2.运价难掌控、运输过程不透明',
          content: '运输配送过程不透明，价格难以掌控，客户对物流配送满意度仅为21%。',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/points2_bg.png'
        },
        {
          id: 3,
          title: '3.人工统计效率低，运营成本居高不下',
          content: '业务数据安全可靠性要求高，需要专业人员，运营成本不断增加否则无法弹性扩张',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/points3_bg.png'
        },
        {
          id: 4,
          title: '4.司机找货难、货主找车难',
          content: '物流市场庞大，但是没有合理的平台整合资源，造成司机难以找到合适的货源，货主发货难。',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/points4_bg.png'
        }
      ],
      superiorityData: [
        {
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/shujv.png',
          name: '强大数据支持',
          content: '平台积累了几十万注册用户及物流企业数据，完成了项目开始最难的从0到1，从1到10的阶段，代理商加盟后可以全部提供当地的客户资源，让代理商直接跳过开始最难的从0到1，从1到10的阶段，促成项目质的飞跃。'
        },
        {
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/nianxing.png',
          name: '优秀的产品粘性',
          content1: '对货主:',
          content2: '我们可以合法合规的开具增值税发票，可以降低经营成本，增加利润，减少企业税负。找司机/货车更加方便快捷，加快业务速度，提升业务量。司机/货车身份会经过严格检验，完全合格，运输过程可以查看，信息透明，安全有保证。',
          content3: '对司机/物流企业：',
          content4: '1.可以寻找货源，节省无用时间。2.可以帮司机给企业代开运输发票以及个人所得税。'
        },
        {
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/yunying.png',
          name: '运营支持',
          content: '支持大宗、普货等运输业务，开单灵活、效率高；支持自主接单、派单、Excel导入、API接口接入等模式。'
        },
        {
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/guocheng.png',
          name: '过程管控',
          content: '从货源发布到货物安全送达，轨迹实时更新，全程动态监控。保证过程的安全、可控。'
        },
      ],
    };
  },
  created() {
    // this.$public.getBanner(16, 0).then(res => {
    //   this.bannerList = res.data.rows;
    // });
    this.setTimer();
  },
  mounted() {
    if (this.$public.isMobile()) {
      window.location.href = 'http://hmmwuliu.net/common/ws-m/statusquo.html';
    }
  },
  methods: {
    setTimer() {
      this.timer = setInterval(() => {
        if (this.pointsIndex > 2) {
          this.pointsIndex = 0;
        } else {
          this.pointsIndex++;
        }
      }, 1500);
    },
    clearTimer() {
      clearInterval(this.timer);
    },
    /**
     * @description: 行业痛点鼠标划入事件
     * @author: 书童
     */
    pointsover(num) {
      this.clearTimer();
      this.pointsIndex = num;
    },
    /**
     * @description: 页面滚动到顶部
     * @author: 书童
     */
    goBottom() {
      let top = this.$refs.box.offsetHeight, scrollTop = document.documentElement.scrollTop,
          clientHeight = document.documentElement.clientHeight;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = scrollTop += 50;
        if (top <= (scrollTop + clientHeight)) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },
  beforeDestroy() {
    this.clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
.title {
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #333333;
  line-height: 42px;
  margin-top: 70px;
}

.title_border {
  width: 40px;
  height: 2px;
  background: #f39801;
  margin: 6px auto 0;
}

.points {
  overflow: hidden;
  height: 662px;

  .pointsBox {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 50px;

    .pointsBox_left {
      display: block;
      height: 422px;
      width: 530px;
      margin-right: 60px;
    }

    .pointsBox_right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      //background: red;
      width: 610px;
      height: 100%;

      .pointsBox_right_item {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .icon_a {
          display: block;
          height: 70px;
          width: 70px;
          margin-right: 30px;
        }

        .icon {
          display: block;
          height: 40px;
          width: 40px;
          margin-right: 45px;
          margin-left: 45px;
          margin-top: 30px;
          margin-bottom: 30px;
        }

        .pointsBox_right_item_right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          width: 440px;

          .pointsBox_title {
            font-size: 18px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: LEFT;
            color: #333333;
            line-height: 25px;
          }

          p {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: LEFT;
            color: #666666;
            line-height: 21px;
            margin-top: 14px;
          }
        }
      }

      .pointsBox_right_item_a {
        padding: 20px 40px 20px 30px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 10px 20px 2px rgba(0, 111, 255, 0.05);
      }
    }
  }
}

#superiority {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 698px;
  width: 100%;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/superiority_bg.png') no-repeat;
  background-size: 100% 100%;

  .container1 {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 1200px;
    height: 698px;
  }

  p {
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: CENTER;
    color: #ffffff;
    line-height: 28px;
    margin-top: 30px;
  }

  img {
    display: block;
    width: 1134px;
    height: 400px;
    margin-top: 50px;
  }
}

.superiority2 {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 698px;
  width: 100%;
  background: #FFFFFF;

  .superiority2_title {
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: LEFT;
    color: #333333;
    line-height: 28px;
    margin-top: 70px;
  }

  p {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: CENTER;
    color: #333333;
    line-height: 22px;
    margin-top: 20px;
  }

  img {
    display: block;
    width: 1134px;
    height: 400px;
    margin-top: 50px;
  }
}

#superiority3 {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 430px;
  width: 100%;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/superiority3_bg.png') no-repeat;
  background-size: 100% 100%;

  .superiority2_title {
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: LEFT;
    color: #FFFFFF;
    line-height: 28px;
    margin-top: 70px;
  }

  p {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: CENTER;
    color: #FFFFFF;
    line-height: 22px;
    margin-top: 20px;
  }

  img {
    display: block;
    width: 1300px;
    height: 215px;
    margin-top: 30px;
  }
}

.chose {
  overflow: hidden;
  width: 1320px;
  height: 570px;
  margin: 0px auto;

  .chose_top {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 205px;
    margin-top: 70px;

    .chose_top_first {
      position: relative;
      width: 400px;
      height: 205px;
      font-size: 82px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: rgba(0, 0, 0, 0.05);
      line-height: 48px;
      padding: 18px 58px;
      box-sizing: border-box;

      .chose_top_first_pos {
        position: absolute;
        left: 58px;
        top: 18px;
        font-size: 30px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 42px;
      }
    }

    .chose_top_item {
      overflow: hidden;
      width: 400px;
      height: 205px;
      border-radius: 20px;
      padding: 0 50px;
      box-sizing: border-box;

      img {
        display: block;
        width: 74px;
        height: 74px;
        margin-bottom: 8px;
        margin-top: 18px;
      }

      .chose_top_item_title {
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 25px;
        padding: 0 10px;
        box-sizing: border-box;
      }

      p {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #666666;
        line-height: 20px;
        margin-top: 10px;
        padding: 0 10px;
        box-sizing: border-box;
      }
    }

    .chose_top_first:hover {
      box-shadow: 0px 10px 20px 2px rgba(0, 111, 255, 0.05);
    }

    .chose_top_item:hover {
      box-shadow: 0px 10px 20px 2px rgba(0, 111, 255, 0.05);
    }
  }
}

#superiority4 {
  width: 100%;
  height: 464px;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/points/group@3x.png') no-repeat;
  background-size: 100% 100%;

  .container2 {
    display: flex;
    justify-content: flex-start;
    width: 1200px;
    height: 464px;
    margin: 0 auto;

    .item {
      overflow: hidden;
      width: 300px;
      height: 464px;

      .item1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        background: rgba(51, 51, 51, 0.30);
        opacity: 1;
        transition: opacity 0.6s;

        & > img {
          display: block;
          width: 70px;
          height: 70px;
        }

        .item1_title {
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          color: #ffffff;
          line-height: 28px;
          margin-top: 20px;
        }
      }

      .item2 {
        display: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 300px;
        height: 464px;
        background: rgba(51, 51, 51, 0.70);
        padding: 0 30px;
        opacity: 0;
        box-sizing: border-box;
        transition: opacity 0.6s;

        .item2_title {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #ffffff;
          line-height: 22px;
        }

        .item2_content {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #ffffff;
          line-height: 20px;
          margin-top: 10px;
        }
      }
    }

    .item:hover {
      .item1 {
        display: none;
      }

      .item2 {
        display: block;
        display: flex;
        opacity: 1 !important;
        transition: opacity 0.6s;
        //flex-direction: column;
        //justify-content: center;
        //align-items: flex-start;
      }
    }
  }
}


</style>